module.exports = __webpack_public_path__ + "img/upgrade-estate.7f8d5ec1.svg";